import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import LoginComponent from '@components/pages/auth/login.component';
import TVPlayerComponent from '@components/pages/tv/player.component';
import { AuthGuard } from './guards/auth.guard';

const routes: Routes = [
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: 'login', component: LoginComponent, pathMatch: 'full' },
  {
    path: 'tv',
    // canActivate: [AuthGuard],
    component: TVPlayerComponent,
    pathMatch: 'full'
  },
  {
    path: 'cms',
    loadChildren: () =>
      import('./modules/cms/index.module').then(m => m.CmsModule)
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
